"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.semverLt = exports.padVersion = exports.updateNpmPackage = exports.installNpmDevPackage = exports.installNpmPackage = exports.getNpmPackageVersion = exports.getNpmLatestVersion = exports.getCrateLatestVersion = void 0;
var https_1 = __importDefault(require("https"));
var spawn_1 = require("../../helpers/spawn");
var cross_spawn_1 = require("cross-spawn");
var app_paths_1 = require("../../helpers/app-paths");
var fs_1 = require("fs");
var semver_1 = __importDefault(require("semver"));
var BASE_URL = 'https://docs.rs/crate/';
function useYarn() {
    return __awaiter(this, void 0, void 0, function () {
        var hasYarnLockfile;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    hasYarnLockfile = fs_1.existsSync(app_paths_1.resolve.app('yarn.lock'));
                    if (!hasYarnLockfile) return [3 /*break*/, 1];
                    return [2 /*return*/, true];
                case 1: return [4 /*yield*/, new Promise(function (resolve) {
                        var _a;
                        var child = cross_spawn_1.sync('npm', ['--version']);
                        resolve(!!((_a = child.status) !== null && _a !== void 0 ? _a : child.error));
                    })];
                case 2: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
function getCrateLatestVersion(crateName) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, new Promise(function (resolve, reject) {
                        var url = "" + BASE_URL + crateName;
                        https_1.default.get(url, function (res) {
                            if (res.statusCode !== 302 || !res.headers.location) {
                                reject(res);
                            }
                            else {
                                var version = res.headers.location.replace(url + '/', '');
                                resolve(version);
                            }
                        });
                    })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
exports.getCrateLatestVersion = getCrateLatestVersion;
function getNpmLatestVersion(packageName) {
    return __awaiter(this, void 0, void 0, function () {
        var child, output, packageJson, child;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, useYarn()];
                case 1:
                    if (_a.sent()) {
                        child = cross_spawn_1.sync('yarn', ['info', packageName, 'versions', '--json'], {
                            cwd: app_paths_1.appDir
                        });
                        output = String(child.output[1]);
                        packageJson = JSON.parse(output);
                        return [2 /*return*/, packageJson.data[packageJson.data.length - 1]];
                    }
                    else {
                        child = cross_spawn_1.sync('npm', ['show', packageName, 'version'], {
                            cwd: app_paths_1.appDir
                        });
                        return [2 /*return*/, String(child.output[1]).replace('\n', '')];
                    }
                    return [2 /*return*/];
            }
        });
    });
}
exports.getNpmLatestVersion = getNpmLatestVersion;
function getNpmPackageVersion(packageName) {
    return __awaiter(this, void 0, void 0, function () {
        var child, output, matches;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, useYarn()];
                case 1:
                    child = (_a.sent())
                        ? cross_spawn_1.sync('yarn', ['list', '--patern', packageName, '--depth', '0'], {
                            cwd: app_paths_1.appDir
                        })
                        : cross_spawn_1.sync('npm', ['list', packageName, 'version', '--depth', '0'], {
                            cwd: app_paths_1.appDir
                        });
                    output = String(child.output[1]);
                    matches = new RegExp(packageName + '@(\\S+)', 'g').exec(output);
                    if (matches === null || matches === void 0 ? void 0 : matches[1]) {
                        return [2 /*return*/, matches[1]];
                    }
                    else {
                        return [2 /*return*/, null];
                    }
                    return [2 /*return*/];
            }
        });
    });
}
exports.getNpmPackageVersion = getNpmPackageVersion;
function installNpmPackage(packageName) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, useYarn()];
                case 1:
                    if (_a.sent()) {
                        spawn_1.spawnSync('yarn', ['add', packageName], app_paths_1.appDir);
                    }
                    else {
                        spawn_1.spawnSync('npm', ['install', packageName], app_paths_1.appDir);
                    }
                    return [2 /*return*/];
            }
        });
    });
}
exports.installNpmPackage = installNpmPackage;
function installNpmDevPackage(packageName) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, useYarn()];
                case 1:
                    if (_a.sent()) {
                        spawn_1.spawnSync('yarn', ['add', packageName, '--dev'], app_paths_1.appDir);
                    }
                    else {
                        spawn_1.spawnSync('npm', ['install', packageName, '--save-dev'], app_paths_1.appDir);
                    }
                    return [2 /*return*/];
            }
        });
    });
}
exports.installNpmDevPackage = installNpmDevPackage;
function updateNpmPackage(packageName) {
    var usesYarn = fs_1.existsSync(app_paths_1.resolve.app('yarn.lock'));
    if (usesYarn) {
        spawn_1.spawnSync('yarn', ['upgrade', packageName, '--latest'], app_paths_1.appDir);
    }
    else {
        spawn_1.spawnSync('npm', ['install', packageName + "@latest"], app_paths_1.appDir);
    }
}
exports.updateNpmPackage = updateNpmPackage;
function padVersion(version) {
    var _a;
    var count = ((_a = version.match(/\./g)) !== null && _a !== void 0 ? _a : []).length;
    while (count < 2) {
        count++;
        version += '.0';
    }
    return version;
}
exports.padVersion = padVersion;
function semverLt(first, second) {
    return semver_1.default.lt(padVersion(first), padVersion(second));
}
exports.semverLt = semverLt;
